import * as React from 'react';

interface ITextHighlighterProps {
  text: string;
  matches?: [number, number][];
}

/**
 * Выделяет жирным совпадения в слове, если что-то вбито в поиск.
 */
export const TextHighlighter: React.FC<ITextHighlighterProps> = ({ text, matches }) => {
  if (!matches || matches.length < 1) {
    return <span>{text}</span>;
  }

  const parts: React.ReactNode[] = [];

  matches.forEach((match, index) => {
    const previousLastIndex = (matches[index - 1] && matches[index - 1][1]) ?? -1;
    if (match[0] > previousLastIndex + 1) {
      parts.push(<span key={index}>{text.substring(previousLastIndex + 1, match[0])}</span>);
    }

    parts.push(<strong key={`strong_${index}`}>{text.substring(match[0], match[1] + 1)}</strong>);
  });

  const lastMatchedIndex = matches[matches.length - 1][1];

  if (text.length - 1 > lastMatchedIndex) {
    parts.push(<span key="last">{text.substring(lastMatchedIndex + 1)}</span>);
  }

  return <span>{parts}</span>;
};
